import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CAUserDto } from 'src/core/models/administration/user/CAUser.dto';
import { MatTableColumnDefinitionModel } from 'src/core/models/mat-table/mat-table-column-definition.model';
import { UserBatchUpdateDepartmentDto } from 'src/core/models/shared/user-batch-update-department.dto';
import { CrudService } from 'src/core/services/crud/crud.service';

@Component({
    selector: 'ca-user-batch-update-department',
    templateUrl: './user-batch-update-department.component.html',
    styleUrl: './user-batch-update-department.component.scss',
    standalone: false
})
export class UserBatchUpdateDepartmentComponent {
  @Output()
  refreshRequested = new EventEmitter();

  @Input()
  selection: SelectionModel<CAUserDto>;

  @Input()
  cls: string;

  updating: boolean = false;
  form: FormGroup;
  dataSource = new MatTableDataSource<CAUserDto>();
  displayedColumns: string[] = [];
  gridColumns: MatTableColumnDefinitionModel[] = [
    {
      columnName: 'username',
      header: this.localizationService.instant('User::Username'),
      binding: 'username',
      valueParser: undefined,
      pipes: undefined,
      width: '50%',
      minWidth: '150px',
      tooltip: undefined,
    },
    {
      columnName: 'departmentName',
      header: this.localizationService.instant('::Department'),
      binding: 'department.name',
      valueParser: (val, obj) => obj.departmentHierarchyName || val,
      pipes: undefined,
      width: '50%',
      minWidth: '150px',
      tooltip: undefined,
    },
  ];

  private _data: CAUserDto[];

  constructor(
    private fb: FormBuilder,
    private localizationService: LocalizationService,
    private modalService: NgbModal,
    private service: CrudService,
    private toastr: ToasterService
  ) {
    this.form = this.fb.group({
      department: [null, { validators: [Validators.required] }],
    });

    for (const gridColumn of this.gridColumns) {
      this.displayedColumns.push(gridColumn.columnName);
    }
  }

  openModal(content): void {
    this.setSelection();
    this.modalService.open(content, { size: 'lg', scrollable: true });
  }

  closeModal(): void {
    this.form.reset();
    this.modalService.dismissAll();
  }

  onSubmit(): void {
    if (this.form.valid) {
      var input: UserBatchUpdateDepartmentDto = {
        departmentId: this.form.get('department').value.id,
        userIds: this.selection.selected.map(u => u.id),
      };
      this.updating = true;

      this.service
        .insertWithoutId(UserBatchUpdateDepartmentDto, input, 'batch/department')
        .subscribe({
          next: () => {
            this.updating = false;
            this.toastr.success(
              this.localizationService.instant(
                'User::BatchUpdate:Department:Success',
                input.userIds.length.toString()
              )
            );
            this.closeModal();
            this.selection.clear();
            this.refreshRequested.emit();
          },
          error: error => {
            this.updating = false;
            this.toastr.error(error.message);
            this.closeModal();
          },
        });
    }
  }

  private setSelection(): void {
    this._data = this.sort(this.selection.selected);
    this.dataSource.connect().next(this._data);
  }

  private sort(data: CAUserDto[]): CAUserDto[] {
    return data.sort((a, b) => {
      if (
        a.department?.name
          ?.toLocaleLowerCase()
          .localeCompare(b.department?.name?.toLocaleLowerCase()) > 0
      )
        return 1;
      if (
        a.department?.name
          ?.toLocaleLowerCase()
          .localeCompare(b.department?.name?.toLocaleLowerCase()) < 0
      )
        return -1;
      if (a['username']?.toLocaleLowerCase().localeCompare(b['username']?.toLocaleLowerCase()) > 0)
        return 1;
      if (a['username']?.toLocaleLowerCase().localeCompare(b['username']?.toLocaleLowerCase()) < 0)
        return -1;
    });
  }
}
